// import { FC, PropsWithChildren } from 'react';

import type { FC } from 'react';

import type { ChipProps } from '@mui/material/Chip';
import Chip from '@mui/material/Chip';

import Skeleton from './skeleton';

interface IProps extends ChipProps {
  width?: string | number;
  height?: string | number;
  preload?: boolean;
}

const AtpChip: FC<IProps> = ({ width, height, preload, ...rest }) => {
  const { className } = rest;

  return preload ? (
    <Skeleton variant="rectangular" height={height} width={width} className={className} />
  ) : (
    <Chip {...rest} className={className} />
  );
};

export default AtpChip;
